import './css/TopImages.css';
import topVideo from "./movie/top_movie.mp4"

function TopImages () {
    return (
        <div className='topImages'>
            <video className='img-fluid' src={topVideo} autoPlay playsInline loop muted preload='none' alt=''/>
            <div className='top-text d-none d-md-block'>
                    <p id='company-name'>N E <span>E X</span></p>
                    <p id='company-copy'>NExt level generation IT technology EXpert group</p>
            </div>
            <div className='neex-name d-none d-md-block'></div>
            <div className='md-top-text d-block d-md-none'>
                    <p id='md-company-name'>N E <span>E X</span></p>
                    <p id='md-company-copy'>NExt level generation IT technology EXpert group</p>
            </div>
        </div>
    );
}

export default TopImages;
